import React from "react";

/**
 * CSS class for petrol (green) / diesel (blue) fuel name labels.
 */
export const getFuelLabelClass = (fuelName) => {
  const name = String(fuelName || "").toLowerCase().trim();
  if (name.includes("diesel")) {
    return "fuel-label-diesel";
  }
  if (name.includes("petrol")) {
    return "fuel-label-petrol";
  }
  return "";
};

/** Hex color for charts (Recharts lines, etc.) */
export const getFuelColor = (fuelName) => {
  const name = String(fuelName || "").toLowerCase().trim();
  if (name.includes("diesel")) {
    return "#1d4ed8";
  }
  if (name.includes("petrol")) {
    return "#1f9d55";
  }
  return "#6b7280";
};

/**
 * Renders a fuel name with petrol/diesel color when displayed as text.
 */
export function FuelLabel({ name, className = "", as: Tag = "span", children, ...props }) {
  const text = children != null ? children : name;
  const cls = `${getFuelLabelClass(name)} ${className}`.trim();
  return React.createElement(Tag, { className: cls || undefined, ...props }, text);
}
